import { useTrackEvent } from '@/composables/useEventTracking'
import { FIBER_STATUS_DETERMINED } from '@/constants/gtm/events'
import type { FiberStatusEvent } from '@/types/gtm/events'
import { isSignupStatus } from '@/types/gtm/types'
import type { LocationQueryValue } from 'vue-router'

const trackSignupStatus = (status: LocationQueryValue | LocationQueryValue[], address: string): void => {
	if (isSignupStatus(status)) {
		const trackedEvent: FiberStatusEvent = {
			event: FIBER_STATUS_DETERMINED,
			category: 'Navigation',
			action: 'view',
			label: 'Service Signup Status',
			address,
			signup_status: status
		}
		useTrackEvent(trackedEvent)
	}
}

export {
	trackSignupStatus
}
